'use client';
import { useEffect } from 'react';
import { sendPv } from '@/tracks/25217';
import { useParams, useSearchParams } from 'next/navigation';
import { getSkuId } from '@/utils/helpers';
export default function DpPvtrackClient() {
  const { sku } = useParams<{ sku: string }>();
  const searchParams = useSearchParams();
  // 切换同一商品的不同规格时，url中会带有ref_sku参数
  const skuid = searchParams.get('ref_sku');

  useEffect(() => {
    // skuid为空，才上报PV。（skuid不空，说明是切换规格，不需要上报PV）
    if (!skuid || !sessionStorage.getItem('initial_skuid')) {
      sendPv.Productdetail_MainPage({ mainskuid: sku, skuid: getSkuId(skuid, sku) });
      sessionStorage.setItem('initial_skuid', sku);
    }
  }, []);
  return null;
}